export default __webpack_public_path__ + "static/media/integrate.5a713e4e.svg";